import { List, styled } from '@mui/material';

const StyledList = styled(List)(({ theme }) => ({
  maxHeight: theme.spacing(118.5),
}));

export default StyledList;
